"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pre = exports.Code = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_ace_1 = require("../react-ace");
exports.Code = ({ className, ...props }) => {
    const mode = className?.replace(/language-/, "") || "";
    return react_1.default.createElement(react_ace_1.Ace, Object.assign({ mode: mode }, props));
};
exports.Code.propTypes = {
    className: prop_types_1.default.string,
};
exports.Pre = ({ children }) => {
    if (children?.props?.originalType === "code") {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    else {
        return react_1.default.createElement("pre", null, children);
    }
};
//# sourceMappingURL=Code.js.map